import T from '../../../common/components/T';
export const getFormData = (usersByEmail) =>
    [
        {
            attribute: 'login',
            required: true,
            disabled: false,
            title: {
                body: <T textName='getFormData-login-title-v1' defaultStr='Ваш ID или email' page='/authentication' />,
                links: false
            },
            name: 'login',
            hint: false,
            type: 'input',
            autocomplete: 'on'
        },
        usersByEmail?.length
            ? {
                  required: true,
                  attribute: 'user_id',
                  title: {
                      body: (
                          <T
                              textName='getFormData-set-username-title'
                              defaultStr='Выберите аккаунт для авторизации'
                              page='/authentication'
                          />
                      )
                  },
                  placeholder: (
                      <T
                          textName='getFormData-set-username-title'
                          defaultStr='Выберите аккаунт для авторизации'
                          page='/authentication'
                      />
                  ),
                  type: 'dropdown',
                  options: usersByEmail
                      ? usersByEmail.map((i) => ({
                            id: i.id,
                            title: i.username
                        }))
                      : []
              }
            : false,

        {
            attribute: 'password',
            required: true,
            disabled: false,
            title: {
                body: <T textName='getFormData-password-title' defaultStr='Введите пароль' page='/authentication' />,
                links: false
            },
            name: 'password',
            placeholder: '******',
            hint: false,
            type: 'password',
            autocomplete: 'on',
            authShowPass: true
        }
    ].filter((i) => i != false);
